import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  //   private apiUrl = `${environment.apiBaseUrl}/your-api-endpoint` // Your API endpoint
  private apiUrl = `${environment.apiBaseUrl}/`

  constructor(private http: HttpClient) {}

  // Method to make the API request
  getData(): Observable<any> {
    return this.http.get(this.apiUrl) // This will hit the interceptor if not excluded
  }

  // Function to fetch an image
  getImage(imageUrl: string): Observable<Blob> {
    return this.http.get(imageUrl, { responseType: 'blob' })
  }
}
